import React from 'react';
import './UserAlreadyExistsModal.css';
import ThemedButton from '../components/ThemedButton';
import { useTranslation } from 'react-i18next';

interface UserAlreadyExistsModalProps {
  onClose?: () => void;
  onAccept?: () => void;
}

const UserAlreadyExistsModal: React.FC<UserAlreadyExistsModalProps> = ({
  onClose,
  onAccept,
}) => {
  const { t } = useTranslation();

  return (
    <div className="user-already-exists-modal-overlay">
      <div className="user-already-exists-modal">
        <div className="user-already-exists-modal-text-wrapper">
          <div>
            <h1 className="user-already-exists-modal-title">
              {t('userAlreadyExistsPage.header')}
            </h1>
            <p className="user-already-exists-modal-message">
              {t('userAlreadyExistsPage.description')}
            </p>
          </div>
          <img src="/images/existing-user.svg" alt="Alert Icon" />
        </div>
        <div className="user-already-exists-modal-buttons-wrapper">
          <ThemedButton
            text={t('global.continue')}
            onClick={() => onAccept && onAccept()}
          />
          <ThemedButton
            text={t('global.cancel')}
            onClick={() => onClose && onClose()}
            color="white"
          />
        </div>
      </div>
    </div>
  );
};

export default UserAlreadyExistsModal;
